<mat-dialog-actions>
  <ion-row class="w-100">
    <ion-col size>
      <p class="formLabelBoldfs18">Color Palatte</p>
    </ion-col>
    <ion-col size="auto" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
</mat-dialog-actions>

<mat-dialog-content class="p-15">
  <ion-row>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Name Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructNameColor" (change)="onOrgStructColorChange($event, 'orgStructNameColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Department Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructDepartmentColor" (change)="onOrgStructColorChange($event, 'orgStructDepartmentColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Box Background Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructBgColor" (change)="onOrgStructColorChange($event, 'orgStructBgColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Structure Lines Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructBorderColor" (change)="onOrgStructColorChange($event, 'orgStructBorderColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Initials Background Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructInitialsBgColor" (change)="onOrgStructColorChange($event, 'orgStructInitialsBgColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Initials Text Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructInitialsTextColor" (change)="onOrgStructColorChange($event, 'orgStructInitialsTextColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Subbordinate Count Background Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructSubbordinateBgColor" (change)="onOrgStructColorChange($event, 'orgStructSubbordinateBgColor')"/>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="formLabelBoldfs16">Subbordinate Count Color</div>
      <div class="mt-10 cardBox">
        <input type="color" class="cp rounded-color-picker" [value]="orgStructColors?.orgStructSubbordinateTextColor" (change)="onOrgStructColorChange($event, 'orgStructSubbordinateTextColor')"/>
      </div>
    </ion-col>
  </ion-row>
</mat-dialog-content>
<mat-dialog-actions>
  <ion-row class="p-0 mt-20 w-100">
    <ion-col class="d-flex float-right">
      <button class="font_medium back_btn mr-30 mr-10ForMobileView" (click)="onClickDefault()">Default</button>
      <button class="font_medium back_btn mr-30 mr-10ForMobileView" (click)="btn1Action()">Cancel</button>
      <button class="font_medium add_btn" (click)="btn2Action()" >Apply</button>
    </ion-col>
  </ion-row>
</mat-dialog-actions>
